// vh-pdp.js — WP-P13: neu strukturiert (Prototyp-JS Zeilen 739–821 als Vorlage für GALERIE/STICKY-CART/
// BUY-BOX-Render-Logik), ES5, Abschnitte mit // === markiert (Bytezählung je Abschnitt im Protokoll).
// Kein Server-Roundtrip: Variantendaten kommen aus dem eingebetteten [data-vh-variants]-JSON.
// Frühere KAUFOPTIONEN/PurchaseOptions-Klasse (WP-P03, eigener Abo-Wähler) ENTFERNT — WP-P13-Verboten,
// Seal Subscriptions übernimmt das UI selbst.
var $ = function (s, c) { return (c || document).querySelector(s); };
var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
function vhEur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

// === BUY-BOX ===
// WP-P15a (21.09.2026): natives <product-form> ersetzt den eigenen fetch('/cart/add')-Weg (der Theme-
// Handler component-product-form.js uebernimmt jetzt POST + Warenkorb-Update, s. Abschnitt am Dateiende
// "add-to-cart -> Sidebar oeffnen"). Klick-Delegation zieht von root (nur noch der "form"-Teil der
// Waehler-Snippet-Aufteilung: Traeger/Groesse/Menge) auf .vh-buybox__buy hoch, weil die Staerke-Chips
// jetzt ausserhalb des Formulars liegen (Brief §3.5 Pos. 9) und root sie sonst nicht mehr erreicht.
// Preislogik ist jetzt abo-bewusst (data-vh-plans, aus variant.selling_plan_allocations): waehrend ein
// Abo aktiv ist (input[name="selling_plan"] im Formular nicht leer), gilt ueberall der Allocation-Preis
// statt Variantenpreis * Mengenstaffel-Rabatt (§3.3, Annahme A-15.1: keine Stapelung).
(function () {
  var root = $('[data-vh-waehler]');
  if (!root) return;
  // WP-P34-Review-Fix (25.09.2026, muss): Gebinde-Wort aus dem Root-Attribut lesen (vh-s2-waehler.liquid
  // setzt data-gebinde-mehrzahl); Default "Flaschen" reproduziert das bisherige Verhalten byte-gleich.
  var gebindeMehrzahl = root.dataset.gebindeMehrzahl || 'Flaschen';
  var buybox = $('.vh-buybox__buy') || root;
  var formEl = root.closest('form');
  var variants = [];
  try { variants = JSON.parse($('[data-vh-variants]', root).textContent); } catch (e) {}
  var plans = {};
  try { plans = JSON.parse($('[data-vh-plans]', root).textContent); } catch (e) {}
  // WP-P40 W9b (30.09.2026, N-Y09): variantId -> Galerie-Slide-Index, aus vh-galerie.liquid [data-vh-slide-map].
  var vhSlideMap = {};
  try { var vhSlideMapEl = $('[data-vh-slide-map]'); if (vhSlideMapEl) vhSlideMap = JSON.parse(vhSlideMapEl.textContent); } catch (e) {}
  var staffelAktiv = root.dataset.staffelAktiv === 'true';
  var vids = $$('[data-vid-input]'), qtyInput = $('[data-qty-input]');
  var priceEl = $('[data-price]'), compareEl = $('[data-compare]'), saveEl = $('[data-save]'), unitEl = $('[data-unit-out]');
  var cta = $('[data-main-cta]'), ctaLabel = $('[data-cta-label]'), ctaPrice = $('[data-cta-price]'), ctaCompare = $('[data-cta-compare]');
  var headprice = $('[data-headprice]');
  // WP-P41 Paket R (02.10.2026): Attrappen-Selektor ersetzt -- data-restock-app umschliesst jetzt den
  // echten App-Block (sw-back-in-stock) statt des alten Eigenbau-Formulars.
  var restock = $('[data-restock-app]');
  // WP-P41 Paket R: Playwright-Check am Relief-Testprodukt bestaetigt, dass der App-Block
  // (sw-back-in-stock/SealApps) zuverlaessig ein echtes, volles "Senden Sie mir eine E-Mail, wenn
  // verfuegbar"-Widget rendert -- es haengt sich per eigenem Skript asynchron (~6-9 s, zwei API-Rufe)
  // AUSSERHALB des Block-Mountpoints in die Seite (kein Kind von data-restock-app-slot, deshalb keine
  // JS-Sichtbarkeitspruefung hier -- die lieferte am 02.10. ein falsches "leer", weil sie zu frueh und
  // am falschen Element pruefte). Der statische Mailto-Hinweis in vh-v2-hero.liquid/vh-s2-hero.liquid
  // greift nur noch, wenn im Schema gar kein @app-Block eingetragen ist (Liquid-Pruefung, kein JS-Timing).
  var aboNote = $('[data-vh-abo-note]', root);
  var tiers = $$('.vh-tier', root);
  var tierSummary = $('[data-staffel-summary]', root);
  var state = { traeger: '', groesse: '', qty: 1, rate: 0 };
  $$('[data-option="traeger"]', root).forEach(function (b) { if (b.getAttribute('aria-checked') === 'true') state.traeger = b.dataset.value; });
  $$('.vh-size', root).forEach(function (b) { if (b.getAttribute('aria-checked') === 'true') state.groesse = b.dataset.value; });

  function activeSize() { return $$('.vh-size', root).filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0]; }
  function findVariant() { return variants.filter(function (v) { return v.traeger === state.traeger && v.groesse === state.groesse; })[0]; }
  function sellingPlanValue() { var i = formEl ? formEl.querySelector('input[name="selling_plan"]') : null; return (i && i.value) ? i.value : ''; }
  function planFor(variantId, planId) {
    var list = plans[String(variantId)] || [];
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(planId)) return list[i]; }
    return null;
  }

  function render(vhSkipTierReset) {
    var sz = activeSize();
    if (!sz) return;
    var base = parseInt(sz.dataset.priceCents, 10) || 0;
    var cmp = parseInt(sz.dataset.compareCents, 10) || 0;
    var variant = findVariant();
    var spId = sellingPlanValue();
    var isAbo = spId !== '';
    var plan = isAbo && variant ? planFor(variant.id, spId) : null;
    var unitPrice = (isAbo && plan) ? plan.price : base;
    // r20: Abo-Rabatt (Selling Plan) und Mengenrabatt multiplizieren sich (Inhaber 22.09., mammaly-Muster);
    // die automatischen Rabatte gelten seit 22.09. auch fuer Abos (appliesOnSubscription: true).
    var rate = staffelAktiv ? state.rate : 0;
    var per = Math.round(unitPrice * (1 - rate));
    var total = per * state.qty;
    var full = (cmp > base ? cmp : base) * state.qty;

    tiers.forEach(function (t) {
      var q = parseInt(t.dataset.value, 10);
      var unitOut = $('[data-staffel-unit]', t), badgeOut = $('[data-staffel-badge]', t), totalOut = $('[data-staffel-total]', t), saveOut = $('[data-staffel-save]', t);
      var r = staffelAktiv ? parseFloat(t.dataset.rate) : 0;
      var pt = Math.round(unitPrice * (1 - r));
      var showBadge = staffelAktiv && r > 0;
      if (unitOut) unitOut.textContent = vhEur(pt);
      if (badgeOut) { badgeOut.hidden = !showBadge; if (showBadge) badgeOut.textContent = '−' + Math.round(r * 100) + ' %'; }
      if (totalOut) totalOut.textContent = q > 1 ? vhEur(pt * q) + ' gesamt' : '';
      if (saveOut) saveOut.textContent = (q > 1 && r > 0) ? 'Sie sparen ' + vhEur((base - pt) * q) : '';
    });
    if (aboNote) aboNote.hidden = true;
    if (tierSummary) {
      if (state.qty > 1) {
        tierSummary.textContent = state.qty + (isAbo ? ' ' + gebindeMehrzahl + ' im Abo: ' + vhEur(total) + ' je Lieferung' : ' ' + gebindeMehrzahl + ': ' + vhEur(total) + ' gesamt') + (full > total + 0.5 ? ' · Sie sparen ' + vhEur(full - total) : '');
      } else tierSummary.textContent = '';
    }
    // r20 (V2): Express-Checkout nur beim Einmalkauf (Shopify blendet beim Abo sonst einen Autorisierungstext ein)
    var expressEl = $('.vh-v2-express');
    if (expressEl) expressEl.hidden = isAbo;
    // r10: Mengen ueber dem verfuegbaren Lager sperren (nur bei verwaltetem Bestand und Policy 'deny');
    // Shopify kappt sonst still auf den Bestand (Beleg 21.09.: quantity=2 gesendet, 1 im Warenkorb bei Lager 1).
    var maxQ = 99;
    if (variant && variant.managed && variant.policy === 'deny' && typeof variant.stock === 'number') maxQ = Math.max(0, variant.stock);
    var activeTierOff = false;
    tiers.forEach(function (t) {
      var q = parseInt(t.dataset.value, 10), off = q > maxQ;
      t.setAttribute('aria-disabled', off ? 'true' : 'false');
      var st = $('.vh-tier__stock', t);
      if (off && !st) { st = document.createElement('span'); st.className = 'vh-tier__stock'; t.appendChild(st); }
      if (st) { st.textContent = (off && maxQ > 0) ? ('nur noch ' + maxQ + ' verfügbar') : ''; if (!st.textContent) st.remove(); } /* SHOPCHECK-0510: kein 'Lager: 0' */
      if (off && t.getAttribute('aria-checked') === 'true') activeTierOff = true;
    });
    // WP-P41 Paket R (02.10.2026): Fix Endlosschleife -- bei maxQ === 0 (Lager komplett 0, verwaltet,
    // Policy "deny", z. B. Relief-Oel) ist JEDE Menge "off", auch die Menge 1, auf die hier zurueckgesetzt
    // wird. Der alte unbedingte "render()"-Aufruf rief sich dadurch synchron immer wieder selbst auf ->
    // RangeError: Maximum call stack size exceeded, Seite haengt komplett (entdeckt beim Playwright-Check
    // des Restock-Widgets, Relief-Testprodukt). vhSkipTierReset laesst den zweiten Durchlauf die Preis-/
    // Kaufbutton-/Restock-Logik unten trotzdem einmal fertig rechnen, ohne ein drittes Mal zurueckzusetzen.
    if (activeTierOff && !vhSkipTierReset) { state.qty = 1; state.rate = 0; if (qtyInput) qtyInput.value = 1; tiers.forEach(function (t) { t.setAttribute('aria-checked', t.dataset.value === '1' ? 'true' : 'false'); }); render(true); return; }

    if (priceEl) priceEl.textContent = vhEur(total);
    if (isAbo) {
      if (compareEl) compareEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    } else {
      var onSale = full > total + 0.5;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = vhEur(full); }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = 'Sie sparen ' + vhEur(full - total); }
    }
    if (unitEl) {
      var mlVal = sz.dataset.ml ? parseFloat(sz.dataset.ml) : 0;
      // WP-P15a: Grundpreis skaliert linear mit dem Stueckpreis (dieselbe Formel wie
      // snippets/vh-grundpreis.liquid, Fallback-Zweig: Preis * 100 / ml) -- so bezieht sich der
      // angezeigte Grundpreis auch im Abo auf den Abo-Stueckpreis, ohne die Liquid-Datei anzufassen.
      if (isAbo && mlVal > 0) { unitEl.textContent = vhEur(Math.round(unitPrice * 100 / mlVal)) + ' / 100 ml'; }
      else if (sz.dataset.unit) { unitEl.textContent = sz.dataset.unit; }
    }
    if (headprice) headprice.textContent = (state.qty > 1 ? '' : 'ab ') + vhEur(per);

    // r9: nur schreiben, wenn sich der Wert aendert (hidden-Input: .value = Content-Attribut -> Mutation -> Schleife)
    if (variant) vids.forEach(function (i) { if (String(i.value) !== String(variant.id)) i.value = variant.id; });
    var available = variant ? variant.available : sz.dataset.stock === '1';
    if (cta) cta.disabled = !available;
    if (ctaLabel) ctaLabel.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
    if (ctaPrice) { ctaPrice.hidden = !available; ctaPrice.textContent = vhEur(total); }
    // r18 (V2): Streichpreis im Kaufbutton = Einmalkauf-Gesamt ohne Rabatt, sobald Staffel oder Abo guenstiger ist
    if (ctaCompare) { var showCmp = available && full > total + 0.5; ctaCompare.hidden = !showCmp; if (showCmp) ctaCompare.textContent = vhEur(full); }
    if (restock) restock.hidden = available;

    var wantMct = state.traeger === 'Bio-MCT-Öl';
    // WP-P41 Paket S (02.10.2026): bei 30 ml die eigenen "-30"-Staffelbilder zeigen (ein Fläschchen,
    // zwei Fläschchen, drei Fläschchen jeweils als 30-ml-Flasche) -- nur wenn das Snippet sie ausgegeben
    // hat (data-src-hanf-30/data-src-mct-30), sonst bleibt es beim 10-ml-Bild (Sleep/Relief/Kapseln etc.).
    var want30 = state.groesse === '30 ml';
    $$('[data-staffel-img]', root).forEach(function (img) {
      var src = wantMct ? img.dataset.srcMct : img.dataset.srcHanf;
      if (want30) {
        var src30 = wantMct ? img.dataset.srcMct30 : img.dataset.srcHanf30;
        if (src30) src = src30;
      }
      if (src && img.getAttribute('src') !== src) img.src = src;
    });

    // WP-P40 W9b (30.09.2026, N-Y09): zuerst die variantengenaue Slide-Map versuchen (deckt 10 ml/30 ml
    // ab, sobald je Groesse ein eigenes variant.featured_image gesetzt ist); ohne Treffer greift wie bisher
    // die reine Traegeroel-Zuordnung (aendert am heutigen Verhalten nichts, solange 10/30 ml dasselbe Bild teilen).
    var galerie = $('[data-vh-galerie]');
    if (galerie && galerie.vhShow) {
      var slideIdx = null;
      if (variant && vhSlideMap.hasOwnProperty(String(variant.id))) slideIdx = vhSlideMap[String(variant.id)];
      if (slideIdx === null || typeof slideIdx === 'undefined') slideIdx = parseInt(state.traeger === 'Bio-MCT-Öl' ? (galerie.dataset.slideMct || '1') : (galerie.dataset.slideHanf || '0'), 10);
      galerie.vhShow(slideIdx);
    }

    // r21: zusaetzliche Felder fuer die V2-Sticky-Leiste (vh-v2.js); V1-Listener nutzt weiter nur price/available/variantTitle
    document.dispatchEvent(new CustomEvent('vh:variantchange', { detail: { price: vhEur(total), available: available, variantTitle: (variant ? variant.groesse : state.groesse) + ' · ' + state.traeger + (state.qty > 1 ? ' × ' + state.qty : ''), qty: state.qty, groesse: (variant ? variant.groesse : state.groesse), traeger: state.traeger, abo: isAbo, compare: (available && full > total + 0.5) ? vhEur(full) : '' } }));
  }

  buybox.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    var opt = btn.dataset.option;
    if (opt === 'staerke') {
      var href = state.traeger === 'Bio-MCT-Öl' ? btn.dataset.hrefMct : btn.dataset.hrefHanfoel;
      if (href) location.href = href;
      return;
    }
    $$('button[data-option="' + opt + '"]', buybox).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    if (opt === 'traeger') {
      state.traeger = btn.dataset.value;
      var is24 = $('[data-requires-traeger]', buybox), hint = $('[data-chip24-hint]', buybox);
      if (is24) { var lock = state.traeger === 'Bio-MCT-Öl'; is24.setAttribute('aria-disabled', lock ? 'true' : 'false'); if (hint) hint.textContent = lock ? 'nur in Hanföl' : '2400 mg'; }
    } else if (opt === 'groesse') { state.groesse = btn.dataset.value; }
    else if (opt === 'menge') { state.qty = parseInt(btn.dataset.value, 10); state.rate = parseFloat(btn.dataset.rate) || 0; if (qtyInput) qtyInput.value = state.qty; }
    render();
  });

  // WP-P15a: Abo-Zustand kommt von Seal Subscriptions, das input[name="selling_plan"] selbst ins
  // Formular schreibt/aendert. change deckt die Umschaltung ueber Seals eigene subs_type-Radios ab,
  // der MutationObserver deckt den Fall ab, dass Seal den Wert nur per Attribut setzt (kein change-Event).
  var changeTarget = formEl || document;
  // r8: verzoegert rendern -- Seals eigener Handler (setzt selling_plan) kann nach unserem laufen.
  changeTarget.addEventListener('change', function (e) { if (e.target && e.target.name && e.target.name.indexOf('subs_type') === 0) { setTimeout(render, 0); setTimeout(render, 400); } });
  // r9: nur auf Seals selling_plan-Feld reagieren, nie auf eigene Schreibvorgaenge (id/quantity) -- sonst Endlosschleife.
  var vhRenderPending = false;
  if (formEl) { new MutationObserver(function (muts) {
    var hit = false;
    for (var k = 0; k < muts.length; k++) { var t = muts[k].target; if (t && t.getAttribute && t.getAttribute('name') === 'selling_plan') { hit = true; break; } }
    if (hit && !vhRenderPending) { vhRenderPending = true; setTimeout(function () { vhRenderPending = false; render(); }, 0); }
  }).observe(formEl, { attributes: true, attributeFilter: ['value'], subtree: true }); }

  // WP-P41 Paket R (02.10.2026): Fake-Handler entfernt -- er ersetzte nur den Text im Browser, ohne dass
  // irgendeine E-Mail-Adresse je irgendwohin ging (Attrappe). Die echte Benachrichtigung uebernimmt jetzt
  // der App-Block "sw-back-in-stock" im Markup (vh-v2-hero.liquid/vh-s2-hero.liquid, data-restock-app).

  // WP-P15a: 1:1 nach assets/section-main-product.js Z. 96-107 -- unser Template hat kein <product-page>,
  // das dies sonst uebernaehme, deshalb hier nachgebaut (Brief §3.4).
  var pf = $('.vh-buybox [data-js-product-form]');
  if (pf) pf.addEventListener('add-to-cart', function () {
    var sb = document.getElementById('site-cart-sidebar'); if (sb && typeof sb.show === 'function') sb.show();
    var cr = document.getElementById('cart-recommendations'); if (cr && typeof cr.generateRecommendations === 'function') cr.generateRecommendations();
  });

  render();
})();

// === TRAEGEROEL-PICK ===
// Trägeröl-Karten (vh-traegeroel) und andere [data-pick]-Elemente setzen nur die Trägeröl-Option des
// aktuellen Produkts — kein eigener Klick-Handler dort, Weiterleitung an den passenden Chip.
(function () {
  $$('[data-pick]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var chip = $('.vh-chip[data-option="traeger"][data-value="' + el.dataset.pick + '"]');
      if (chip) chip.click();
      var buybox = $('.vh-buybox');
      if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

// === GALERIE ===
(function () {
  var gal = $('[data-vh-galerie]');
  if (!gal) return;
  var stage = $('[data-galerie-stage]', gal);
  var imgs = $$('[data-slide]', stage);
  var thumbs = $('[data-galerie-thumbs]', gal);
  var counter = $('[data-galerie-counter]', gal);
  var cur = 0;
  function show(n) {
    if (!imgs.length) return;
    cur = (n + imgs.length) % imgs.length;
    imgs.forEach(function (im, idx) { im.classList.toggle('is-active', idx === cur); });
    if (thumbs) $$('[data-thumb]', thumbs).forEach(function (b, idx) { b.setAttribute('aria-pressed', idx === cur ? 'true' : 'false'); if (idx === cur) b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
    if (counter) counter.textContent = (cur + 1) + ' / ' + imgs.length;
  }
  var prev = $('[data-galerie-prev]', gal), next = $('[data-galerie-next]', gal);
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });
  if (thumbs) thumbs.addEventListener('click', function (e) { var b = e.target.closest('[data-thumb]'); if (b) show(parseInt(b.dataset.thumb, 10) - 1); });
  var x0 = null;
  stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(dx < 0 ? cur + 1 : cur - 1); x0 = null; });
  document.addEventListener('keydown', function (e) { if (/^(INPUT|TEXTAREA)$/.test(e.target.tagName)) return; if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); });
  gal.vhShow = show;
})();

// === STICKY-CART ===
(function () {
  var bar = $('[data-sticky-cart]');
  var mainCta = $('[data-main-cta]');
  if (!bar || !mainCta) return;
  var price = $('[data-sticky-price]', bar);
  var variantEl = $('[data-sticky-variant]', bar);
  var cta = $('[data-sticky-cta]', bar);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // r8: mobil (< 900 px) sichtbar, sobald der Kaufbutton nicht im Viewport ist (auch vor dem Erreichen --
        // Muster des Theme-Elements sticky-add-to-cart); Desktop erst nach dem Vorbeiscrollen.
        var on = !en.isIntersecting && (window.innerWidth < 900 || en.boundingClientRect.top < 0);
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(mainCta);
  }
  document.addEventListener('vh:variantchange', function (e) {
    var v = e.detail;
    if (price) price.textContent = v.price;
    if (variantEl) variantEl.textContent = v.variantTitle;
    if (cta) { cta.disabled = !v.available; cta.textContent = v.available ? 'In den Warenkorb — ' + v.price : 'Ausverkauft'; }
  });
  if (cta) cta.addEventListener('click', function () {
    if (mainCta.form && typeof mainCta.form.requestSubmit === 'function') mainCta.form.requestSubmit(mainCta);
    else mainCta.click();
  });
})();

// === PRODUKTTEXT-TABS ===
// Mobil natives <details>-Akkordeon (kein JS nötig). Ab 900 px: Progressive Enhancement zu Tabs.
(function () {
  var root = $('[data-vh-tabs-root]');
  if (!root) return;
  var mq = window.matchMedia('(min-width: 900px)');
  var btns = $$('[data-tab-btn]', root), panels = $$('[data-tab-panel]', root);
  function activate(id) {
    btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('aria-controls') === id ? 'true' : 'false'); });
    panels.forEach(function (p) { p.classList.toggle('is-tab-active', p.id === id); });
  }
  function enterTabs() { panels.forEach(function (p) { p.open = true; }); activate(panels.length ? panels[0].id : ''); }
  btns.forEach(function (b) { b.addEventListener('click', function () { if (mq.matches) activate(b.getAttribute('aria-controls')); }); });
  root.addEventListener('click', function (e) { if (mq.matches && e.target.closest('summary')) e.preventDefault(); }, true);
  function onModeChange() { if (mq.matches) enterTabs(); }
  if (mq.addEventListener) mq.addEventListener('change', onModeChange); else if (mq.addListener) mq.addListener(onModeChange);
  onModeChange();
})();

/* vh-abo-knoepfe 2026-10-11 */
(function () {
  if (window.__vhAboKnoepfe) return; window.__vhAboKnoepfe = true;
  var css = '.vh-ak{margin:10px 0 4px;width:100%;flex:1 1 100%}.vh-ak__t{font-size:15px;margin:0 0 8px}' +
    '.vh-ak__r{display:grid;grid-template-columns:repeat(var(--vh-ak-n,3),1fr);gap:8px}' +
    '.vh-ak .vh-ak__b{appearance:none!important;border:1.5px solid #d5dad6!important;background:#fff!important;color:#2f3a33!important;' +
    'border-radius:10px!important;min-height:46px!important;padding:8px 4px!important;font:inherit;font-size:15px!important;font-weight:700!important;' +
    'line-height:1.2!important;white-space:nowrap!important;cursor:pointer;box-shadow:none!important;width:100%!important;display:block!important;text-transform:none!important;letter-spacing:0!important}' +
    '.vh-ak .vh-ak__b[aria-pressed="true"]{background:#e6f2e8!important;border:2px solid #3f8f52!important;color:#1f2a22!important}' +
    '.vh-ak .vh-ak__b:focus-visible{outline:2px solid #3f8f52!important;outline-offset:2px}' +
    '.vh-ak-weg{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function kurz(x) { return x.replace(/^jeden Monat$/i, '1 Monat').replace(/^alle (\d+) Monate$/i, '$1 Monate'); }
  function bau(sel) {
    if (sel.__vhAk || sel.options.length < 2) return; sel.__vhAk = true;
    var box = sel.closest('.sls-select-container') || sel.parentElement;
    var wrap = document.createElement('div'); wrap.className = 'vh-ak';
    var t = document.createElement('p'); t.className = 'vh-ak__t'; t.textContent = 'Wählen Sie den Lieferrhythmus:';
    var row = document.createElement('div'); row.className = 'vh-ak__r'; row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Lieferrhythmus'); row.style.setProperty('--vh-ak-n', String(Math.min(sel.options.length, 3)));
    var btns = [];
    function sync() { btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.value === sel.value)); }); }
    Array.prototype.forEach.call(sel.options, function (o) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'vh-ak__b'; b.value = o.value; b.textContent = kurz(o.text.trim());
      b.addEventListener('click', function () {
        if (sel.value !== o.value) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        sync();
      });
      btns.push(b); row.appendChild(b);
    });
    wrap.appendChild(t); wrap.appendChild(row);
    // Seals eigene Zeile (Label „Lieferung“ + Liste) ausblenden, aber im DOM lassen
    var zeile = box.parentElement && box.parentElement.contains(box) ? box.parentElement : box;
    if (zeile.querySelectorAll('select').length !== 1 || zeile.querySelector('input[type=radio]')) zeile = box;
    zeile.classList.add('vh-ak-weg'); zeile.parentNode.insertBefore(wrap, zeile.nextSibling);
    sel.addEventListener('change', sync); sync();
  }
  function scan() { document.querySelectorAll('select[name="subs_interval"]').forEach(bau); }
  scan();
  var n = 0, iv = setInterval(function () { scan(); if (++n > 40) clearInterval(iv); }, 250);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { if (ms[i].addedNodes.length) { scan(); break; } }
  }).observe(document.body, { childList: true, subtree: true });
})();
